export const encode = (data) => {
    try {
      return btoa(unescape(encodeURIComponent(data)));
    } catch (error) {
      console.error("Encoding error:", error);
      return null;
    }
  };
  
  export const decode = (encodedData) => {
    try {
      return decodeURIComponent(escape(atob(encodedData)));
    } catch (error) {
      console.error("Decoding error:", error);
      return null;
    }
  };